import React from "react";
import {
  Box,
  CardHeader as MuiCardHeader,
  IconButton,
  styled,
  Typography,
} from "@mui/material/";
import makeStyles from "@mui/styles/makeStyles";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

const Root = styled("div")(({ theme, headerColor }) => ({
  display: "flex",
  padding: "0 10px 0 20px !important",
  borderBottom: headerColor ? "1px solid #efeff1" : "none",
  backgroundColor: headerColor || "#ffffff",
}));

const Title = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "fontColor", // ⛔ Prevents fontColor from being passed to DOM
})(({ fontColor }) => ({
  color: fontColor || "inherit",
  "& button": {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
}));

const Avatar = styled("div")(() => ({
  width: "18px",
  height: "18px",
}));

const Content = styled("div")(() => ({
  width: "100%",
}));


const ColorCode = styled(({ colorCode, ...rest }) => <div {...rest} />)(
  ({ colorCode }) => ({
    width: "8px",
    height: "8px",
    backgroundColor: colorCode,
    borderRadius: "50%",
    marginLeft: "8px",
  })
);

const CardHeader = (props) => {
  const {
    cardTitle,
    handleExpandClick,
    expanded,
    collapsible,
    headerColor,
    fontColor,
    icon,
    colorCode,
    style,
    isTitleJsx,
  } = props;

  const StyledCardHeader = styled(MuiCardHeader)(({ theme, colorCode }) => ({
    borderBottom: "1px solid #efeff1",
    padding: "0 16px !important",
    borderLeft: colorCode ? `3px solid ${colorCode} !important` : "none",
  }));

  return (
    <StyledCardHeader
      avatar={icon}
      title={
        <Root headerColor={headerColor}>
          <Box display="flex" alignItems="center" width="100%">
            {isTitleJsx ? (
              cardTitle
            ) : (
              <Title fontColor="#000">{cardTitle}</Title>
            )}
            <ColorCode colorCode={colorCode} />
          </Box>
          {collapsible && (
            <IconButton
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
              disableFocusRipple
              disableRipple
              size="large"
            >
              {expanded ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          )}
        </Root>
      }
      titleTypographyProps={{ variant: "h2" }}
    />
  );

};

export default CardHeader;
